import {useAppSelector} from '@/hooks';
import {useIsCurrentPageVideo} from '@Hooks/poster-editor/useIsCurrentPageVideo';

export const useIsTimelineButtonVisible = (): boolean => {
  const isCurrentPageVideo = useIsCurrentPageVideo();
  const isDesktopTimelineToggleOn = useAppSelector((state) => {
    return state.posterEditor.isDesktopTimelineToggleOn;
  });
  const isVersionHistoryModeActive = useAppSelector((state) => {
    return state.posterEditor.isVersionHistoryModeActive;
  });

  return isCurrentPageVideo && !isDesktopTimelineToggleOn && !isVersionHistoryModeActive;
};
